export interface TwoFaImportFields {
  twoFaPassword?: string
  twoFaPhoneDigits?: number
}

/**
 * Собирает 2FA-поля импорта клиента:
 * - Если пароль непустой — отправляется только `twoFaPassword` (digits игнорируются).
 * - Если пароль пуст, а `digits` в диапазоне 1..15 — отправляется `twoFaPhoneDigits`.
 * - Пустые/невалидные значения опускаются (никаких ключей).
 */
export const buildTwoFaImportFields = (
  password: string,
  digits: string,
): TwoFaImportFields => {
  const p = password.trim()
  if (p) {
    return { twoFaPassword: password }
  }
  const d = digits.trim()
  if (d) {
    const n = Number(d)
    if (Number.isInteger(n) && n >= 1 && n <= 15) {
      return { twoFaPhoneDigits: n }
    }
  }
  return {}
}

export const appendTwoFaFields = (
  formData: FormData,
  fields: TwoFaImportFields,
): void => {
  if (fields.twoFaPassword !== undefined) {
    formData.append("twoFaPassword", fields.twoFaPassword)
  }
  if (fields.twoFaPhoneDigits !== undefined) {
    formData.append("twoFaPhoneDigits", String(fields.twoFaPhoneDigits))
  }
}
